export function logIPPMInteraction(name) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  // TODO: fire events to AMP ?

  // eslint-disable-next-line no-console
  console.log("IPPM Interaction Event: ".concat(name), target, value);
}
export function trackPackageSelected(packageData, isRecommended) {
  // TODO: implement this FN
  // eslint-disable-next-line no-console
  console.log("trackPackageSelected Event:", packageData.id, isRecommended);

  // SM?.ProductAnalytics?.trackInteraction('pricing selected plan', {
  //     pageName: getPageName(),
  //     paidFeatures: getPaidFeatures(),
  //     selectedPackageId: packageData.id.toString(),
  //     selectedPackageName: packageData.class_name,
  //     isRecommended,
  // });
}